import React from "react";
import { HelpCircle } from "lucide-react";

export const GUIDE_URLS = {
  bd: "https://doc.minibio.pro/guide-bd/",
  minisite: "https://minibio.pro/tuto-minisite/",
  assistant: "https://doc.minibio.pro/guide-assistant/",
};

export default function HelpLink({ url, className = "" }) {
  return (
    <a
      href={url}
      target="_blank"
      rel="noopener"
      title="Guide d'utilisation"
      aria-label="Guide d'utilisation"
      className={`help-link ${className}`}
    >
      <HelpCircle className="help-link__icon" aria-hidden="true" />
    </a>
  );
}
